export default {
    HEADER: 'Proizvod',
    PLACEHOLDER_NAME: 'Unesite naziv proizvoda',
    LABEL_NAME: 'Naziv proizvoda',
    LABEL_PRICE: 'Cena',
    PLACEHOLDER_PRICE: 'Unesite cenu',
    PLACEHOLDER_DISCOUNTED_PRICE: 'Unesite sniženu cenu',
    LABEL_DISCOUNTED_PRICE: 'Snižena cena',
    LABEL_PLACE: 'Lokal',
    LABEL_PRODUCT_CATECORY: 'Kategorija',
    LABEL_STATUS: 'Status',
    PLACEHOLDER_DESCRIPTION: 'Unesite opis',
    LABEL_DESCRIPTION: 'Opis',
    LABEL_COMPANY: 'Kompanija',
    SAVE_BUTTON: 'Sačuvaj',
    CANCEL_BUTTON: 'Poništi',
    DISCOUNTED_PRICE_INFO:
        'Polje snižena cena je isključeno dok ne unesete cenu. Molimo vas ostavite prazno polje ukoliko cena nema sniženje. Za iznos snižene cene unesite vrednost veću od 0, a manju od vrednosti cene!',
    INDIVIDUAL_PRICES: 'Pojedinačne cene',
    UPDATE_ALL_CONFIGS: 'Ažuriraj proizvod u svim lokalima',
};

export const PRODUCT_FORM_VALIDATIONS = {
    PRICE_REQUIRED: 'Polje je obavezno',
    PRICE_POSITIVE: 'Mora biti pozitivan broj',
    PRICE_NUMBER: 'Mora biti broj',
    DISCOUNTED_PRICE_LOWER_THAN_PRICE: 'Snižena cena mora biti manja od cene',
    DISCOUNTED_PRICE_POSITIVE: 'Mora biti pozitivan broj',
    DISCOUNTED_PRICE_NUMBER: 'Mora biti broj',
    DISCOUNTED_PRICE_REQUIRED: 'Polje je obavezno',
};
